(() => {
  let dispose = () => {};
  function init() {
    dispose();
    const overlay = document.querySelector('.dm-hero-logo');
    const header = overlay?.closest('.shopify-section--header');
    const logo = header?.querySelector('.header__logo');
    const hero = document.querySelector('#main > .shopify-section:first-child .slideshow');
    const image = overlay?.querySelector('img');
    if (!overlay || !header || !logo || !hero || !image) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    let frame = 0;
    const update = () => {
      frame = 0;
      const target = logo.getBoundingClientRect();
      const bounds = hero.getBoundingClientRect();
      const ratio = image.naturalWidth / image.naturalHeight;
      const blocked = document.querySelector('header-sidebar[open], header-search[open], cart-drawer[open], x-header details[open]');
      if (motion.matches || blocked || !Number.isFinite(ratio) || bounds.height < 150) {
        header.classList.remove('dm-logo-active');
        return;
      }
      if (!document.documentElement.classList.contains('dm-logo-home')) {
        document.documentElement.classList.add('dm-logo-home');
        schedule();
        return;
      }
      const distance = Math.max(160, Math.min(bounds.height * 0.65, innerHeight * 0.6));
      const progress = Math.min(1, Math.max(0, scrollY / distance));
      header.classList.toggle('dm-logo-active', progress < 1);
      document.documentElement.classList.add('dm-logo-home');
      const initialWidth = Math.min(innerWidth * (innerWidth < 700 ? 0.84 : 0.78), 1350, bounds.height * 0.32 * ratio) * 0.8 * (innerWidth < 700 ? 1 : 0.85);
      hero.style.setProperty('--dm-hero-content-top', `${bounds.height * 0.30 + initialWidth / ratio / 2 + (innerWidth < 700 ? 24 : 40)}px`);
      if (progress === 1) return;
      const width = initialWidth + (target.width - initialWidth) * progress;
      const startX = (innerWidth - initialWidth) / 2;
      const startY = bounds.top + scrollY + bounds.height * 0.30 - initialWidth / ratio / 2;
      const x = startX + (target.left - startX) * progress;
      const y = startY + (target.top - startY) * progress;
      overlay.style.width = `${width}px`;
      overlay.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const options = { signal: abort.signal, passive: true };
    window.addEventListener('scroll', schedule, options);
    window.addEventListener('resize', schedule, options);
    window.addEventListener('pageshow', schedule, options);
    image.addEventListener('load', schedule, options);
    motion.addEventListener('change', schedule, options);
    const resize = new ResizeObserver(schedule);
    resize.observe(hero);
    resize.observe(logo);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    dispose = () => {
      abort.abort(); resize.disconnect(); observer.disconnect(); cancelAnimationFrame(frame);
      header.classList.remove('dm-logo-active');
      document.documentElement.classList.remove('dm-logo-home');
    };
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => dispose());
})();
